import React, {useEffect, useRef, useState} from "react";
import ReactDOM from "react-dom";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Grid,
  Pagination,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import {alert} from "src/services/alert";
import axios from "axios";
import {API_URL_PROD, BASE_URL, IMG_BASE_URL} from "src/config/constants";
import CloseIcon from "@mui/icons-material/Close";
import Confirm from "./ConfirmDialog";

const modalRoot = document.querySelector("#image-picker");

const pageSize = 15;

export const VideoPickerDialog = ({title, multiple, visible, onClose, onSelect}) => {
  const ref = useRef();
  const [videos, setVideos] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(visible);
  const [uploading, setUploading] = useState(false);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  useEffect(() => {
    getVideos();
  }, [page]);

  function getVideos() {
    let qPage = page <= 0 ? 0 : (page - 1)
    axios
      .post(`${API_URL_PROD}/video/all`, {page: qPage, size: pageSize, type: "video"})
      .then((res) => {
        const {code, msg, data, total} = res.data;
        if (code === 1) {
          setVideos(data);
          setTotal(total);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const handleConfirmSelection = () => {
    //console.log('==========> HandleConfirmSelection selected : %o', selected);
    onSelect(selected.map((s) => s.path).join(","));
    setOpen(false);
  };

  function handlePageChange(event, page) {
    // console.log(page)
    setSelected([]);
    setPage(page);
  }

  function handleImgClick(item) {
    const imgs = [...selected];
    const idx = imgs.findIndex((a) => a.id === item.id);
    console.log("===========> imgs : %o, item: %o, idx : %o", imgs, item, idx)
    if (idx === -1) {
      if (imgs.length < 1 || multiple) {
        imgs.push(item);
      } else {
        imgs[0] = item;
      }
    } else {
      imgs.splice(idx, 1);
    }

    setSelected(imgs);
  }

  function handleUpload(e) {
    console.log(e.target.files);
    if (e.target.files.length == 0) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", e.target.files[0]);

    axios
      .post(`${API_URL_PROD}/upload/video/bulk`, formData)
      .then((res) => {
        const {code, msg, data} = res.data;
        if (code === 1) {
          ref.current.value = null;
          setVideos([...[data], ...videos].slice(0, pageSize));
          setSelected([]); // 重置
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setUploading(false);
      });
  }

  function handleDelPictures() {
    if (!selected.length) return;

    Confirm({
      message: "操作不可恢复,确定删除云视频吗?",
      onConfirm() {
        axios
          .post(`${API_URL_PROD}/video/del`, {ids: selected.map(item => item.id)})
          .then((res) => {
            const {code, msg, data} = res.data;
            if (code === 1) {
              // setPictures(data);
              getVideos();
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除视频", err);
          });
      },
    });
  }

  function renderImages() {
    // console.log(selected)
    return videos.map((item, index) => {
      const {id, path} = item;
      const active = selected.findIndex((a) => a.id === id) > -1;

      return (
        <Grid item key={index}>
          <Stack
            key={id}
            sx={{
              cursor: "pointer",
              border: active ? "2px solid #5fb878" : "2px solid transparent",
            }}
            onClick={() => handleImgClick(item)}
          >
            <video
              src={path}
              loading="lazy"
              style={{
                width: 100,
                height: 100,
                objectFit: "contain",
              }}
            />
          </Stack>
        </Grid>
      );
    });
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              // color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon/>
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" my={3}>
          <ButtonGroup>
            <Button disabled={selected.length === 0} onClick={handleConfirmSelection}>
              使用选中视频
            </Button>
            <Button sx={{position: "relative", borderRadius: 0}} component="label" htmlFor="contained-button-file">
              上传视频{" "}
              <input
                ref={ref}
                accept="video/*"
                id="contained-button-file"
                multiple={true}
                type="file"
                onChange={handleUpload}
                style={{
                  position: "absolute",
                  visibility: "hidden",
                }}
              />
            </Button>

            <Button disabled={selected.length === 0} onClick={handleDelPictures}>
              删除视频
            </Button>
          </ButtonGroup>
        </Stack>

        <Grid container spacing={1} columns={5} pb={4}>
          {renderImages()}
        </Grid>

        <Pagination count={Math.ceil(total / pageSize)} variant="outlined" shape="rounded" onChange={handlePageChange}/>
      </DialogContent>

      <Dialog open={uploading}>
        <DialogContent>
          <Stack alignItems="center">
            <CircularProgress sx={{mb: 2}}/>
            <Typography>视频上传中，请稍等。。。</Typography>
          </Stack>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
};

const VideoPicker = ({
                       title = "请选择需要上传的视频", multiple = false, onSelect = () => {
  }, onClose = () => {
  }
                     }) => {
  ReactDOM.unmountComponentAtNode(modalRoot);
  ReactDOM.render(<VideoPickerDialog visible={true} onClose={onClose} onSelect={onSelect} title={title}
                                     multiple={multiple}/>, modalRoot);
};

export default VideoPicker;
